<template>
	<h-disclosure-panel>
		<slot></slot>
	</h-disclosure-panel>
</template>
